import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const config = createMultiStyleConfigHelpers(inputAnatomy.keys);

const texas = config.definePartsStyle({
  field: {
    bg: 'texas.bg.800',
    px: 3,
    py: 5,
    borderBottom: '2px solid',
    borderBottomColor: 'gray.600',
    borderRadius: 'none',
    color: 'white',
    _placeholder: {
      color: 'gray.200',
    },
    transition: 'border-color 200ms ease',
    _focus: {
      borderBottomColor: 'texas.sand.100',
    },
    _light: {
      bg: 'gray.10',
      _placeholder: {
        color: 'gray.400',
      },
      borderBottomColor: 'gray.100',
      _focus: {
        borderBottomColor: 'texas.burntSienna.100',
      },
    },
  },
});

const entityDirectory = config.definePartsStyle({
  field: {
    background: 'entityDirectory.inputBackground',
    border: '1px solid',
    borderColor: 'entityDirectory.secondaryBorder',
    borderRadius: 0,
    color: 'entityDirectory.text',
    _placeholder: { color: 'entityDirectory.mutedText' },
    _hover: { borderColor: 'entityDirectory.mutedText' },
    _focusVisible: {
      borderColor: 'entityDirectory.primaryBackground',
      boxShadow: 'none',
    },
  },
  element: { color: 'entityDirectory.mutedText' },
});

const navigationBreadcrumb = config.definePartsStyle({
  field: {
    background: 'navigation.contextBackground',
    borderColor: 'navigation.contextBorder',
    color: 'navigation.breadcrumbCurrent',
    _placeholder: { color: 'navigation.contextMuted' },
    _hover: { borderColor: 'navigation.breadcrumbSeparator' },
    _focusVisible: {
      borderColor: 'texasBrand.500',
      boxShadow: 'none',
    },
  },
});

const baseStyle = config.definePartsStyle({
  field: {
    _disabled: {
      opacity: 0.8,
    },
    _light: { color: 'texas.bg.900' },
    _dark: {
      ':-webkit-autofill': {
        WebkitTextFillColor: 'white !important',
      },
      ':-webkit-autofill:hover': {
        WebkitTextFillColor: 'white !important',
      },
      ':-webkit-autofill:focus': {
        WebkitTextFillColor: 'white !important',
      },
    },
  },
  addon: {
    height: 'fit-content',
    bg: 'transparent',
    color: 'gray.200',
    _light: { color: 'gray.500' },
  },
  element: {
    color: 'gray.200',
    fontWeight: 'bold',
    _light: { color: 'gray.500' },
  },
});

export default config.defineMultiStyleConfig({
  defaultProps: { size: 'sm' },
  baseStyle,
  variants: {
    entityDirectory,
    navigationBreadcrumb,
    texas,
  },
});
